export const REDIRECT_VIEW_KEY = 'redirect-view-key';
export const STORAGE_KEY_SESSION = 'session';
// Maximum scaling factor to allow showing signature sticky in margin
export const PAGE_PADDING = 10;
export const PAGES_MARGIN_BOTTOM = 44;
export const VIEW_MIDPOINT_PADDING = 0.1;

export const SIGNER_UI_PAGES = {
    ATTACHMENT: 'ATTACHMENT',
    DECLINE: 'DECLINE',
    HTML: 'HTML',
    OVERVIEW_PAGE: 'OVERVIEW_PAGE',
    PDF: 'PDF',
    SUMMARY: 'SUMMARY',
    THANK_YOU: 'THANK_YOU',
    THANK_YOU_HOST: 'THANK_YOU_HOST'
};

export const REASSIGN_SCHEME_TYPES = {
    EMAIL: 'NONE',
    QNA: 'CHALLENGE',
    SMS: 'SMS',
    SSO: 'SSO'
};

export const REASSIGN_STEPS = {
    REASSIGN: 'reassign',
    AUTH: 'auth'
};

export const RECIPIENT_STATUS = {
    NONE: 'none',
    COMPLETED: 'completed',
    CURRENT_SIGNER: 'current_signer',
    FUTURE_SIGNER: 'future_signer',
    REVIEWER: 'reviewer',
    OWNER_FINISHER: 'owner_finisher'
};
